import jsonApi from './json-api';

const API_SECTION = 'cert';

interface CertClassRequest {
  cert_body: string;
}

interface CertClassResponse {
  cert_class: string;
}

/** Backend historically returned PascalCase `CertClass` (no json tag); develop may return `cert_class`. */
type CertClassApiResponse = {
  cert_class?: string;
  CertClass?: string;
};

export interface MockCert {
  pure_pem: string;
  thumbprint: string;
  attributes: {
    common_name: string;
    country: string;
    given_name: string;
    inn_legal_entity: string;
    locality: string;
    ogrn: string;
    organization: string;
    position: string;
    province: string;
    serial_number: string;
    snils: string;
    street_address: string;
    surname: string;
  };
}

function normalizeCertClass(data: CertClassApiResponse | null | undefined): CertClassResponse {
  return {
    cert_class: data?.cert_class || data?.CertClass || '',
  };
}

function certClass(cert_body: string): Promise<CertClassResponse> {
  if (!cert_body?.length) {
    return Promise.resolve({ cert_class: '' });
  }
  return jsonApi
    .post<CertClassRequest, CertClassApiResponse>(`${API_SECTION}/class`, {
      cert_body,
    })
    .then(normalizeCertClass);
}

function certMockBulk({ isRegistered }: { isRegistered: boolean }): Promise<any> {
  const url = isRegistered ? 'cert/mock/bundle/registered' : 'cert/mock/bundle';

  return jsonApi.get(url).catch((error) => {
    console.error('Error fetching the certificate bundle:', error);
    return null;
  });
}

export { certClass, certMockBulk };
